const tips = [
  {
    icon: "ri-focus-3-line",
    title: "时间线要写清楚",
    desc: "按「什么时候、谁、做了什么、有哪些旁证」的顺序写，别用情绪词替代事实，编辑一眼能看懂才愿意跟进。",
  },
  {
    icon: "ri-screenshot-2-line",
    title: "截图带时间戳",
    desc: "关键对话尽量截图保存，画面里带时间、昵称会更可信。整理成一张时间轴或编号文件夹，提交时最省事。",
  },
  {
    icon: "ri-lock-password-line",
    title: "先隐去敏感信息",
    desc: "涉及当事人联系方式、住址、证件等隐私，投稿前先打码并说明可公开程度。保护他人，也保护自己。",
  },
  {
    icon: "ri-error-warning-line",
    title: "拿不准就先别发",
    desc: "来源不明、无法核实的信息请先搁置。传播未经证实的爆料，既难被采纳，也可能给自己惹来麻烦。",
  },
  {
    icon: "ri-chat-3-line",
    title: "一次性把料给全",
    desc: "别挤牙膏式地一段段补。核心内容、旁证、时间线一次给齐，能显著提升审稿优先级与采纳率。",
  },
  {
    icon: "ri-archive-drawer-line",
    title: "重要备份留底",
    desc: "提交前在本地留一份完整备份，避免素材丢失或需二次补充时找不到原始内容。",
  },
];

export default function Tips() {
  return (
    <section id="tips" className="scroll-mt-24 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <div className="lg:sticky lg:top-24">
              <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-100 px-3 py-1 text-xs font-semibold text-primary-700">
                <i className="ri-quill-pen-line" aria-hidden="true"></i>
                投稿守则
              </span>
              <h2 className="mt-4 text-2xl font-bold text-foreground-950 md:text-4xl">
                这样投，瓜料更容易被采
              </h2>
              <p className="mt-4 text-base leading-relaxed text-foreground-600">
                编辑部每天收到的投稿不少，真正决定「用不用」的往往不是料多刺激，而是信息是否清楚、真实、可核实。守住这六条，能帮你离被采纳更近一步。
              </p>

              <div className="relative mt-8 overflow-hidden rounded-3xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20minimal%20flat%20illustration%20of%20an%20editor%20desk%20with%20checklist%2C%20magnifier%20over%20a%20phone%20screen%20with%20chat%20bubbles%2C%20watermelon%20coral%20red%20and%20mint%20green%20palette%20on%20cream%20background%2C%20soft%20rounded%20shapes%2C%20playful%20editorial%20style%2C%20clean%20composition&width=900&height=700&seq=tips-check-x1&orientation=portrait"
                  alt="编辑台审稿核对清单插画"
                  className="h-72 w-full object-cover object-top md:h-80"
                />
                <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-primary-950/70 to-transparent px-5 pb-5 pt-14">
                  <p className="text-sm font-medium text-background-50">
                    「信息真实可核实」永远是投稿的第一道门槛。
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:col-span-3">
            {tips.map((t) => (
              <article
                key={t.title}
                className="group flex flex-col rounded-2xl border border-background-200/70 bg-background-100/50 p-5 transition-colors hover:border-accent-200 hover:bg-background-100"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-accent-500 text-background-50 transition-transform group-hover:scale-105">
                  <i className={`${t.icon} text-lg`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-4 text-base font-bold text-foreground-950">{t.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}